<template>
  <div class="loading-overlay">
    <div class="loading-backdrop"></div>
    <div class="loading-content">
      <img
        class="loading-logo"
        src="/img/logos/logo-negativo.png"
        alt="S.O.S Contingencias"
      />
      <div class="loading-line">
        <div class="loading-line-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  pointer-events: auto;
  animation: fadeIn 0.35s ease-out;
}

.loading-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: -1;
}

.loading-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  animation: contentIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.loading-logo {
  display: block;
  width: min(520px, 90vw);
  height: auto;
  max-height: 220px;
  object-fit: contain;
  filter: drop-shadow(0 4px 20px rgba(0, 0, 0, 0.2));
  animation: logoFloat 3.2s ease-in-out infinite;
}

.loading-line {
  width: 180px;
  height: 4px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  overflow: hidden;
}

.loading-line-fill {
  height: 100%;
  width: 34%;
  background: linear-gradient(90deg, #fff, rgba(255, 255, 255, 0.9));
  border-radius: 4px;
  animation: lineRun 1.35s ease-in-out infinite;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes contentIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes logoFloat {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.02);
    opacity: 0.98;
  }
}

@keyframes lineRun {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(380%); }
}
</style>
